import React, { useState } from 'react';
import { bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import { intlShape, injectIntl, FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import config from '../../config';
import { LINE_ITEM_NIGHT, LINE_ITEM_DAY, propTypes } from '../../util/types';
import * as validators from '../../util/validators';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import {
  Button,
  Form,
  FieldCurrencyInput,
  FieldCheckbox,
  FieldCheckboxGroup,
  InlineTextButton,
} from '../../components';
import css from './EditListingHealthForm.module.css';
import { riskFactorOptions } from '../../marketplace-custom-config';
import arrayMutators from 'final-form-arrays';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';

export const EditListingHealthFormComponent = props => (
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    render={formRenderProps => {
      // console.log(20, props);
      const {
        className,
        disabled,
        ready,
        handleSubmit,
        intl,
        invalid,
        pristine,
        saveActionMsg,
        updated,
        updateInProgress,
        fetchErrors,
        form,
        errors,
        values,
        userNativeLang,
        history,
      } = formRenderProps;
      // console.log(37, 'values', values);

      const handleChemicalRisk = val => {
        // console.log(40, val);
        form.change('ChemicalRisk', val);
      };

      const unitType = config.bookingUnitType;
      const isNightly = unitType === LINE_ITEM_NIGHT;
      const isDaily = unitType === LINE_ITEM_DAY;

      const classes = classNames(css.root, className);
      const submitReady = (updated && pristine) || ready;
      const submitInProgress = updateInProgress;
      const { updateListingError, showListingsError } = fetchErrors || {};

      const decsPlaceholderText = intl.formatMessage({
        id: 'EditListingHealthForm.descPlaceholder',
      });
      const descriptionRequiredMessage = intl.formatMessage({
        id: 'EditListingDescriptionForm.descriptionRequired',
      });

      const { riskFactors, RiskFactorDesc } = values;

      const riskFactorsHasDescription =
        // riskFactors?.length > 0 &&
        // RiskFactorDesc?.length > 0 &&
        (RiskFactorDesc || [])?.every(m => m.value);

      // console.log(787, riskFactorsHasDescription);

      const submitDisabled = invalid || disabled || submitInProgress || !riskFactorsHasDescription;

      return (
        <Form onSubmit={handleSubmit} className={classes}>
          {updateListingError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingPricingForm.updateFailed" />
            </p>
          ) : null}
          {showListingsError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingPricingForm.showListingFailed" />
            </p>
          ) : null}

          <div className={css.subHeadingContainer}>
            <div className={css.RiskHeading}>
              <FormattedMessage id="EditListingHealthForm.RiskFactorHeading" />
            </div>
            <span className={css.RiskHeadingDesc}>
              <FormattedMessage id="EditListingHealthForm.RiskFactorHeadingDesc" />
            </span>
          </div>

          <div className={css.RiskFactorWrap}>
            <FieldCheckboxGroup
              // className={css.features}
              selectedClassName={css.customSelectedCheckbox}
              className={css.customCheckbox}
              selectedValuesArray={values?.riskFactors}
              id="riskFactors"
              key={'riskFactors'}
              name={'riskFactors'}
              options={riskFactorOptions}
              userNativeLang={userNativeLang}
              showTooltip={true}
              form={form}
              values={values}
              descriptionRequiredMessage={descriptionRequiredMessage}
              decsPlaceholderText={decsPlaceholderText}
              // validate={composeValidators(required(RequiredMessage))}
            />
          </div>

          {/* <FieldCheckbox
            id="ChemicalRisk"
            name="ChemicalRisk"
            label="Chemical Risks"
            value="ChemicalRiskClicked"
            onChange={handleChemicalRisk}
          /> */}

          <div className={css.ButtonContainer}>
            <Button
              className={css.submitButton}
              type="submit"
              inProgress={submitInProgress}
              disabled={submitDisabled}
              ready={submitReady}
            >
              {values?.riskFactors === undefined || values?.riskFactors?.length === 0 ? (
                <FormattedMessage id="SignupForm.signUpSkip" />
              ) : (
                <>{saveActionMsg}</>
              )}
            </Button>
            <InlineTextButton
              type="button"
              className={css.cancelBtn}
              onClick={() => {
                // console.log(1);
                history.replace(
                  createResourceLocatorString('ManageListingsPage', routeConfiguration())
                );
              }}
            >
              <FormattedMessage id="SignupForm.Cancel" />
            </InlineTextButton>
          </div>
        </Form>
      );
    }}
  />
);

EditListingHealthFormComponent.defaultProps = { fetchErrors: null };

EditListingHealthFormComponent.propTypes = {
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  fetchErrors: shape({
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
};

export default compose(injectIntl)(EditListingHealthFormComponent);
